export const RazorPayPercentage = 1.7;
export const CashfreeUtilityPercentage = 1.7;
export const CashfreeEduPercentage = 1.85;
export const CashfreefastPercentage = 2;
export const ZwitchPercentage = 1.85;
